import { createStyles } from "src/styles/theme";

export type StylesClasses = keyof typeof styles;

const styles = createStyles({
  statsCardWrapper: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
    justifyContent: "center",
    padding: "15px",
  },
  statsCard: {
    width: "400px",
    height: "170px",
  },
  dashboardTableWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "40px",
    marginTop: "50px",
    width: "80vw",
  },
  heading: {
    height: "50px",
    opacity: "80%",
    borderBottom: "1px solid lightgrey",
  },
  topHeader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "end",
  },
});

export default styles;
